import styled from 'styled-components';
export const SOSSimpleDropDownContainer = styled.section`
  font-size: 0.6rem;
  .sos-sim-drp {
    // margin: 3px 1px 5px 0px;
    font-size: 0.6rem;
  }
  .ant-select-selection-search {
    min-width: 100%;
  }
  .ant-select-selection-overflow-item {
    min-width: 100%;
  }
  .ant-select-dropdown {
    font-size: 0.6rem;
  }
`;
